import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-circle-char',
  templateUrl: './circle-char.component.html',
  styleUrls: ['./circle-char.component.scss'],
  standalone: true,
})
export class CircleCharComponent {
  @Input() char: string;
}
